
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.45 1.484h1.706v-.89a.594.594 0 011.188 0v.89h8.312v-.89a.594.594 0 011.188 0v.89h1.707c1.35 0 2.449 1.1 2.449 2.45V16.55C19 17.9 17.901 19 16.55 19H2.45A2.452 2.452 0 010 16.55V3.935c0-1.35 1.099-2.45 2.45-2.45zM1.186 16.551c0 .697.565 1.262 1.262 1.262h14.102c.697 0 1.262-.565 1.262-1.262V6.717a.186.186 0 00-.186-.186H1.373a.186.186 0 00-.185.186v9.834z"}})])
          )
        }
      }
    